import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  Box,
  Heading,
  Text,
  Input,
  Button,
  ButtonGroup,
  Flex,
  FormControl,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  IconButton,
  Icon,
} from '@chakra-ui/react';

import { HiUpload } from 'react-icons/hi';
import { CloseIcon } from '@chakra-ui/icons';

import { useColors } from './colors';

import { downloadShippingFileFormatApi } from 'features/suppliers/suppliers.api';

const ShippingUpload = ({
  shippingFile,
  onFileChange,
  onClearFile,
  onUpload,
  isUploading,
  lastUploadDate,
  onViewPrices,
}) => {
  const dispatch = useDispatch();
  const { downloadShippingFormatStatus } = useSelector((state) => state.suppliers);
  const { backgroundCardColor, textColor, secondaryTextColor } = useColors();

  const handleDownloadFormat = () => {
    dispatch(downloadShippingFileFormatApi());
  };

  return (
    <Box p={6} bg={backgroundCardColor} borderRadius="lg" boxShadow="sm" h="300px">
      <Flex justify="space-between" align="center" mb={2}>
        <Heading size="lg" color={textColor}>
          Shipping Upload
        </Heading>
        <ButtonGroup spacing={2}>
          <Button
            variant="outline"
            colorScheme="blue"
            size="md"
            onClick={onViewPrices}
          >
            View shipping prices
          </Button>
          <Button
            colorScheme="blue"
            size="md"
            onClick={handleDownloadFormat}
            isLoading={downloadShippingFormatStatus === 'pending'}
            loadingText="Downloading..."
          >
            Download File Format
          </Button>
        </ButtonGroup>
      </Flex>
      <Text fontSize="sm" color={secondaryTextColor} mb={6}>
        Last Shipping Upload Date: {lastUploadDate}
      </Text>
      <FormControl mb={4} maxW="50%">
        <InputGroup size="md">
          <InputLeftElement pointerEvents="none" h="full">
            <Icon as={HiUpload} color="gray.400" />
          </InputLeftElement>
          <Input
            type="file"
            pt={2}
            pl={10}
            accept=".csv,.xlsx"
            onChange={onFileChange}
            color={textColor}
            value={shippingFile ? '' : undefined}
            sx={{
              '::file-selector-button': {
                display: 'none',
              },
              '&::placeholder': {
                color: textColor,
              },
            }}
            cursor="pointer"
            _placeholder={{ color: textColor }}
          />
          {shippingFile && (
            <InputRightElement>
              <IconButton
                icon={<CloseIcon />}
                size="sm"
                variant="ghost"
                colorScheme="red"
                onClick={onClearFile}
                aria-label="Clear file"
              />
            </InputRightElement>
          )}
        </InputGroup>
        {shippingFile && (
          <Text fontSize="sm" color={textColor} mt={1}>
            {shippingFile.name}
          </Text>
        )}
      </FormControl>
      {shippingFile && (
        <Flex justify="flex-end">
          <Button
            colorScheme="blue"
            size="md"
            w="200px"
            onClick={onUpload}
            isLoading={isUploading}
            loadingText="Uploading..."
          >
            Upload
          </Button>
        </Flex>
      )}
    </Box>
  );
};

export default ShippingUpload;
